// SPDX-License-Identifier: AGPL-3.0-or-later

import {SettingsSection} from '@app/features/app/components/dialogs/shared/SettingsSection';
import {SettingsTabContainer, SettingsTabContent} from '@app/features/app/components/dialogs/shared/SettingsTabLayout';
import {CommunicationTabContent} from '@app/features/user/components/modals/tabs/privacy_safety_tab/CommunicationTab';
import {ConnectionsTabContent} from '@app/features/user/components/modals/tabs/privacy_safety_tab/ConnectionsTab';
import {DataDeletionTabContent} from '@app/features/user/components/modals/tabs/privacy_safety_tab/DataDeletionTab';
import {DataExportTabContent} from '@app/features/user/components/modals/tabs/privacy_safety_tab/DataExportTab';
import {MentionPreferenceTabContent} from '@app/features/user/components/modals/tabs/privacy_safety_tab/MentionPreferenceTab';
import {SensitiveContentTabContent} from '@app/features/user/components/modals/tabs/privacy_safety_tab/SensitiveContentTab';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';

const PrivacySafetyTab: React.FC = observer(() => {
	const {t} = useLingui();
	return (
		<SettingsTabContainer>
			<SettingsTabContent>
				<SettingsSection
					id="connections"
					title={t`Connections`}
					description={t`Control who can send you friend requests and direct messages`}
				>
					<ConnectionsTabContent />
				</SettingsSection>
				<SettingsSection
					id="communication"
					title={t`Communication`}
					description={t`Control who can call you and add you to group chats`}
				>
					<CommunicationTabContent />
				</SettingsSection>
				<SettingsSection
					id="mention-preference"
					title={t`Mention Preference`}
					description={t`Control whether replies to your messages default to @mentioning you`}
				>
					<MentionPreferenceTabContent />
				</SettingsSection>
				<SettingsSection
					id="sensitive-content"
					title={t`Sensitive Content`}
					description={t`Control how mature or sensitive media is filtered in different contexts`}
				>
					<SensitiveContentTabContent />
				</SettingsSection>
				<SettingsSection
					id="data-export"
					title={t`Data Export`}
					description={t`Download a complete package of your account data, including all messages and attachment URLs`}
				>
					<DataExportTabContent />
				</SettingsSection>
				<SettingsSection
					id="data-deletion"
					title={t`Data Deletion`}
					description={t`Permanently delete all messages you have sent across the platform`}
				>
					<DataDeletionTabContent />
				</SettingsSection>
			</SettingsTabContent>
		</SettingsTabContainer>
	);
});

export default PrivacySafetyTab;
